
    export enum TokenType {
        Word = 1,
        And = 2,
        Or = 3,
        Not = 4,
        OpenBracket = 5,
        CloseBracket = 32,
        OpenSquareBracket = 543534,
        CloseSquareBracket = 554,
        Phrase = 6,
        PotentialFieldName = 7,
        DefiniteFieldName = 8,
        Number = 44,
        DefiniteDate = 55,
        PotentialDateOperator = 11, // Eg Before, After, From, On
        Near = 11111,
        Wildcard = 777,
        WOperator = 123123,
        Within = 442,
        PotentialOf = 222212,
        DefiniteOf = 111121,
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/helpers/search-tree/token-type.ts